module.exports = __webpack_public_path__ + "img/lh.d525424f.jpg";